import { Col, Row } from "antd";
import MoyasarForm from "../../../../components/Moyasar/MoyasarForm";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import { setItems, setMobile } from "../../../../apis/slices/moyasarSlice";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../../apis/store";
import { useState } from "react";

interface Props {
  items: any[];
  mobile: string;
}
const SponsorDonation = ({ items, mobile }: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const [displayMoyasar, setDisplayMoyasar] = useState<boolean>(false);

  const openMoyasar = () => {
    setDisplayMoyasar(true);
    dispatch(setMobile(mobile));
    dispatch(setItems(items));
  };

  return (
    <>
      {/* eslint-disable-next-line eqeqeq */}
      {items.reduce((a, b) => b.amount + a, 0) != 0 && (
        <Row>
          <Col xxl={4} xl={4} lg={4} md={4} sm={6} xs={6}>
            <PrimaryButton
              title="سداد"
              className="takaful--sponsor-orphan-card-button"
              onClick={() => openMoyasar()}
            />
          </Col>
        </Row>
      )}
      <MoyasarForm
        amount={items.reduce((a, b) => b.amount + a, 0)}
        description="Takaful"
        open={displayMoyasar}
        handleClose={() => setDisplayMoyasar(false)}
      />
    </>
  );
};
export default SponsorDonation;
